import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { LookupResponse } from '../../responses/risk-classification/lookup.response';

@Injectable({
  providedIn: 'root'
})
export class LookupRiskService extends CommonService{

  constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  getLookup(idProtocol: number = null): Observable<LookupResponse>{
    let uri = `Lookup?`;

    if (idProtocol) {
      uri = uri + `idProtocol=${idProtocol}&`
    }
      
    return this.httpClient.get<LookupResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiRiskClassification) + uri, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }
}
